import gql from 'graphql-tag';

export const getContentTotalQuantityClaimed = gql(/* GraphQL */ `
  query getContentTotalQuantityClaimed($contentId: UUID!) {
    contentFeatureQuantityClaimed(_id: $contentId)
  }
`);
